export default __webpack_public_path__ + "static/1056-cb57599f3ed2ca3d2a8049fcd65a6b6c.gif";